export default __webpack_public_path__ + "static/Plots0009-8baca5b6df43f16c09148eb07eb22611.jpg";